// Los correos del simulador de semanas (08-10): lo que la pantalla hace con ellos.
//
// El servidor (backend/core/simulador_semanas.py y simulador_reloj.py) pone el TEXTO de cada
// correo dentro de la acción o del cambio que lo manda: `correo: { clave, asunto, cuerpo }`,
// o `correo: { clave, sin_texto }` si no se pudo redactar. Y si se le pide, los manda al buzón
// de pruebas y contesta en `correos_mandados` (backend/core/simulador_correos.py).
//
// Aquí no se redacta ni se decide nada: se recogen para pintarlos y se dice cómo fue el envío.
// Lógica pura: sin React y sin red. La usan AdminSimuladorPage y SimuladorPasoAPaso.

/** Los correos de un paso del reloj, con de quién es cada uno y cuándo tocaba. */
export const correosDelPaso = (filas) => (Array.isArray(filas) ? filas : []).flatMap((f) => (
    ((f && f.cambios) || []).filter((c) => c && c.correo)
        .map((c) => ({ ...c.correo, nombre: f.nombre, cliente_id: f.id, cuando: c.cuando }))));

/** Un cambio sin el texto de su correo: así entra en el historial, que se guarda en el navegador. */
export const sinElCorreo = (cambio) => {
    const { correo, ...resto } = cambio || {};
    return resto;
};

/** Las filas como se le mandan al servidor para avanzar: sin los cambios del paso anterior,
 *  que el servidor no lee y que ahora llevan el texto entero de cada correo. */
export const filasParaAvanzar = (filas) => (Array.isArray(filas) ? filas : []).map((f) => {
    const { cambios, ...resto } = f || {};
    return resto;
});

/**
 * La casilla «Mandar también el correo de prueba» vale para UNA petición (08-10): se desmarca
 * sola en cuanto el servidor contesta que mandó, intentó mandar o se negó. Así veinte pasos
 * seguidos no son doscientos correos. Si en ese paso no había ningún correo, sigue marcada:
 * no se ha gastado. `envio` es el `correos_mandados` de la respuesta.
 */
export const seGastaLaCasilla = (envio) => Boolean(envio) && (!envio.se_puede || (envio.habia || 0) > 0);

const cuantos = (n) => (n === 1 ? '1 correo de prueba' : `${n} correos de prueba`);

/** Cómo fue el envío, en una frase. '' si no se pidió mandar nada. */
export const resumenDelEnvio = (envio) => {
    if (!envio) return '';
    if (!envio.se_puede) return `No se mandó ningún correo de prueba. ${envio.motivo || ''}`.trim();
    const mandados = envio.mandados || [];
    if (!mandados.length) return 'No había ningún correo que mandar.';
    const salieron = mandados.filter((m) => m.salio).length;
    let frase;
    if (salieron === 0) frase = 'No salió ningún correo de prueba.';
    else if (salieron === mandados.length) frase = `${salieron === 1 ? 'Salió' : 'Salieron'} ${cuantos(salieron)} a ${envio.buzon}.`;
    else frase = `Salieron ${salieron} de ${cuantos(mandados.length)} a ${envio.buzon}.`;
    if (envio.sin_mandar_por_el_tope > 0) {
        frase += ` Había ${envio.habia}: como mucho se mandan ${envio.tope} cada vez.`;
    }
    return frase;
};
